export const formSettings = {
    submit: {
        labels: [],
        alignment: 'center',
        defaultLabel: 'Register'
    },
    navigation:{
        next:{
            labels: [],
            defaultLabel: 'Next'
        },
        previous:{
            labels: [],
            defaultLabel: 'Back'
        }
    },
    authorizedFormMode: false
    
}